import Dispatcher from '../../dispatcher';
import { actions } from '../../constants/sidebar/actions';

export const showFsDetails = () =>
    Dispatcher.handleSidebarAction({ type: actions.SHOW_FITTING_STATION_DETAILS });

export const hideFsDetails = () =>
    Dispatcher.handleSidebarAction({ type: actions.HIDE_FITTING_STATION_DETAILS });
